import {
  employeeGroupHasLegalEntity,
  employeeGroupLegalEntity,
} from 'modules/core/store/collections/legalEntities'
import LegalEntity from 'modules/core/store/models/LegalEntity'

import { employeeEmployeeGroup } from 'modules/employees/store/collections/employeeEmployeeGroup'
import type Employee from 'modules/employees/store/models/Employee'

export const employeeLegalEntity = (employee: Employee): LegalEntity => {
  return employeeGroupLegalEntity(employeeEmployeeGroup(employee))
}

export const employeeLegalEntityId = (employee: Employee): number => {
  return employeeEmployeeGroup(employee).attributes.legal_entity_id
}

export const employeeHasBrazilianLegalEntity = (employee: Employee): boolean => {
  if (employeeGroupHasLegalEntity(employeeEmployeeGroup(employee))) {
    return employeeLegalEntity(employee).country === LegalEntity.countryDefaults.br
  }

  return false
}
